// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorBoundary__container__3qMN7 layout__fill-center__3V8Ju text__select-text__KUePQ"};